import { createElementObject, createTileLayerComponent, updateGridLayer, withPane } from './core';
import type { WMSTileLayer as LeafletWMSTileLayer, WMSOptions, WMSParams } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { LayerProps, LeafletContextInterface } from './core';

export interface WMSTileLayerProps extends WMSOptions, LayerProps {
    params?: WMSParams
    url: string
}

export const WMSTileLayer = createTileLayerComponent(function createWMSTileLayer({ eventHandlers, params ={} , url , ...options }: WMSTileLayerProps, context: LeafletContextInterface) {
    void eventHandlers;
    const layer = new L.TileLayer.WMS(url, {
        ...params,
        ...withPane(options, context)
    });
    return createElementObject(layer, context);
}, function updateWMSTileLayer(layer: LeafletWMSTileLayer, props: WMSTileLayerProps, prevProps: WMSTileLayerProps) {
    updateGridLayer(layer, props, prevProps);
    if (props.params != null && props.params !== prevProps.params) {
        layer.setParams(props.params);
    }
});
